import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: "AIzaSyDfc7pM6JLXzq0s6UzqzxxMk-Aps1_yCVA",
  version: "weekly",
});

const mapElement = document.getElementById("map");

if (mapElement) {
  loader.load().then(() => {
    // Settings
    var zoomLevel = 13;

    // Positions
    var center = {
      lat: 50.69,
      lng: 3.98,
    };

    const enghien = {
      lat: 50.693988,
      lng: 4.040164,
    };

    const bassily = {
      lat: 50.688943,
      lng: 3.927168,
    };

    // Adapt settings for mobile navigation
    if (window.innerWidth < 648) {
      zoomLevel = 11;
    }

    // Map

    const map = new google.maps.Map(mapElement, {
      center: center,
      zoom: zoomLevel,
    });

    // Enghien marker and info window
    const marker1 = new google.maps.Marker({
      position: enghien,
      map: map,
    });

    const infoWindow1 = new google.maps.InfoWindow({
      content:
        '<p style="margin-bottom: 8px; text-decoration: underline;"><b>Cabinet d\'Enghien</b></p><p>Rue de Bruxelles, 12<br />7850 ENGHIEN</p>',
    });

    infoWindow1.open(map, marker1);

    marker1.addListener("click", () => {
      infoWindow1.open(map, marker1);
    });

    // Bassilly marker and info window
    const marker2 = new google.maps.Marker({
      position: bassily,
      map: map,
    });

    const infoWindow2 = new google.maps.InfoWindow({
      content:
        '<p style="margin-bottom: 8px; text-decoration: underline;"><b>Cabinet de Bassilly</b></p><p>Rue de Grammont, 20<br />7830 BASSILLY</p>',
    });

    infoWindow2.open(map, marker2);

    marker2.addListener("click", () => {
      infoWindow2.open(map, marker2);
    });
  });
}
